<template>
    <el-dialog :title="title+'模板'" width="50%"
               :close-on-click-modal="false"
               append-to-body :visible.sync="visible">
        <el-form size="small" :model="form" ref="form" label-width="100px"  v-loading="loading" @keyup.enter.native="doSubmit()" @submit.native.prevent>
            <el-form-item label="模板名称：" prop="name" :rules="[{ required: true, message: '模板名称不能为空', trigger: 'blur' }]">
                <el-input v-model.trim="form.name" maxlength="10" placeholder="请输入模板名称（限10字）"
                          clearable></el-input>
            </el-form-item>
            <el-transfer v-loading="loading" filterable
                         ref="transfer"
                         v-model="form.selId"
                         :titles="['选择数据', '已选数据']"
                         target-order="push"
                         :props="{key: 'id',label: 'fieldName'}"
                         :data="transferData">
                      <span slot-scope="{ option }">
                        {{ option.fieldName }}
                      </span>
            </el-transfer>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import Sortable from 'sortablejs'

    export default {
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                templateOpt: [],
                form: {
                    id: '',
                    name: '',
                    selId: [],
                    selectId: [],
                    selectList: []
                },
                transferData: [],
            }
        },
        methods: {
            init(id, method) {
                this.form.selId = []
                this.templateOpt = []
                this.transferData = []
                this.method = method
                this.form.id = id || ''
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.initSortable()
                    if(method === 'add') {
                        this.getInitData()
                    } else {
                        this.getTemplateInfo()
                    }
                })
            },
            // 获取初始化数据
            getInitData() {
                this.loading = true
                this.form.selId = []
                this.form.selectList = []
                this.$axios(this.api.metadata.businessinit).then(res => {
                    if(res.status) {
                        this.transferData = res.data
                    } else {
                        this.$message.error(res.msg)
                    }
                    this.loading = false
                })
            },
            // 获取模板字段
            getTemplateInfo() {
                this.loading = true
                this.form.selId = []
                this.$axios(this.api.metadata.selectInfo + '/' + this.form.id).then(res => {
                    if(res.status) {
                        this.form.name = res.data.name
                        this.transferData = res.data.selectList.concat(res.data.uncheckedList)
                        res.data.selectList.map(item => {
                            this.form.selId.push(item.id)
                        })
                    } else {
                        this.$message.error(res.msg)
                    }
                    this.loading = false
                })
            },
            // 初始化拖拽排序
            initSortable() {
                const that = this
                const transfer = this.$refs.transfer.$el
                const rightPanel = transfer.getElementsByClassName('el-transfer-panel')[1].getElementsByClassName('el-transfer-panel__body')[0]
                const rightEl = rightPanel.getElementsByClassName('el-transfer-panel__list')[0]
                Sortable.create(rightEl, {
                    onEnd({ newIndex, oldIndex }) {
                        that.form.selId.splice(newIndex, 0, that.form.selId.splice(oldIndex, 1)[0])
                        const newArray = that.form.selId.slice(0)
                        that.form.selId = []
                        that.$nextTick(function () {
                            that.form.selId = newArray
                        })
                    }
                })
            },
            doSubmit() {
                if (!this.form.selId.length) {
                    this.$message.warning('已选数据不能为空')
                    return
                }
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.form.selectList = []
                        this.form.selId.map(id => {
                            this.transferData.map(item => {
                                if(id == item.id) {
                                    this.form.selectList.push(item)
                                }
                            })
                        })
                        let api = this.api.metadata.infoAdd
                        if(this.method == 'edit') {
                            api = this.api.metadata.infoUpdateSave
                        }
                        this.$axios(api, this.form, 'post').then(res => {
                            if (res.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error('保存失败')
                            }
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .el-transfer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .el-transfer >>> .el-transfer-panel {
        width: 35% !important;
    }
</style>
